"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.additionalSelfClosing = exports.allowedAttributes = exports.allowedTags = void 0;
// list of allowed tags for sanitizing html content in template-service and Template feature in bringg-web
// this array used with default allowed tags from sanitize-html lib
var svgTags = ['svg', 'rect', 'circle', 'ellipse', 'line', 'polyline', 'polygon', 'path', 'defs', 'text'];
var otherTags = [
    'img',
    'html',
    'body',
    'head',
    'style',
    'h3',
    'h4',
    'h5',
    'h6',
    'h1',
    'h2',
    'dd',
    'dt',
    'hr',
    'q',
    'blockquote',
    'p',
    'a',
    'ul',
    'ol',
    'nl',
    'li',
    'b',
    'i',
    'strong',
    'em',
    'strike',
    'code',
    'hr',
    'br',
    'div',
    'caption',
    'pre'
];
var tableTags = ['thead', 'table', 'td', 'tr', 'th', 'tbody'];
exports.allowedTags = __spreadArray(__spreadArray(__spreadArray([], otherTags, true), svgTags, true), tableTags, true);
var baseAllowedAttributes = [
    'id',
    'class',
    'title',
    'style',
    'align',
    'bgcolor', // deprecated
    'width',
    'height',
    'border'
];
var svgAttributes = __spreadArray([
    'height',
    'width',
    'viewbox',
    'x',
    'y',
    'xmlns',
    'stroke',
    'fill',
    'rx',
    'ry',
    'cx',
    'cy',
    'r',
    'x1',
    'x2',
    'y1',
    'y2',
    'points',
    'd',
    'id',
    'offset',
    'style',
    'font-size',
    'font-family'
], baseAllowedAttributes, true);
var tableAttributes = __spreadArray(__spreadArray([], baseAllowedAttributes, true), ['valign', 'cellpadding', 'cellspacing'], false);
exports.allowedAttributes = __assign(__assign(__assign(__assign({}, otherTags.reduce(function (acc, next) {
    acc[next] = baseAllowedAttributes;
    return acc;
}, {})), svgTags.reduce(function (acc, next) {
    acc[next] = svgAttributes;
    return acc;
}, {})), tableTags.reduce(function (acc, next) {
    acc[next] = tableAttributes;
    return acc;
}, {})), { 
    // overriding `a` and `img` since they have their own specific attributes
    a: __spreadArray(['href', 'name', 'target', 'rel', 'alt'], baseAllowedAttributes, true), img: __spreadArray(['src', 'height', 'width', 'alt', 'sizes'], baseAllowedAttributes, true), html: ['lang'] });
exports.additionalSelfClosing = ['rect', 'circle', 'ellipse', 'line', 'polyline', 'polygon', 'path'];
//# sourceMappingURL=allowed-html-template-tags.js.map